import styled, { css } from 'styled-components'
import {
  BORDER_GRAY,
  SUMMER_SKY,
  BLUE_BACKGROUND,
  SECONDARY_TEXT,
} from 'constants/colors'
import { Flex } from 'components/common/styles'

export const SignatureInitialsWrapper = styled.div`
  margin-right: 16px;
  width: 100%;
`

export const InitialsContainer = styled.div`
  margin-top: 6px;
  font-size: 16px;
  line-height: 22px;
  color: ${SECONDARY_TEXT};
`

export const SignatureContainer = styled.div<{ isActive?: boolean }>`
  height: 87px;
  padding: 16px;
  border-radius: 8px;
  border: 1.4px solid ${({ isActive }) => (isActive ? SUMMER_SKY : BORDER_GRAY)};
  width: 100%;

  img {
    width: 100%;
    margin-top: auto;
    margin-bottom: auto;
    max-height: 55px;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${BLUE_BACKGROUND};
    `}
`

export const IconButtonContainer = styled.div`
  > button {
    min-width: 87px;
    height: 87px;
    padding: 16px;
    border-radius: 8px;
    border: 1.4px solid ${BORDER_GRAY};
  }
`

export const ImageContainer = styled(Flex)`
  margin-left: 8px;
  height: 55px;
`

export const ActionsContainer = styled(Flex)`
  padding: 0 24px;
`
